import React, { useState, useEffect } from "react";
import {
  getAttendenceData,
  insertMarkAttendence,
} from "../../services/dataService";
import { Link } from "react-router-dom";
import { data } from "jquery";
import toast from "react-hot-toast";

function AttendancePending() {
  const UID = localStorage.getItem("userId");

  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedProfitCenter, setSelectedProfitCenter] = useState("");
  const [departments, setDepartments] = useState([]);
  const [profitCenters, setProfitCenters] = useState([]);
  const [individualCheck, setIndividualcheck] = useState([]);
  const departmentIds = localStorage.getItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepartmentId = departmentIds.split(",")[0] || null;
  const isAdmin = localStorage.getItem("IsAdmin");

  // Get yesterday's date as default
  const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split("T")[0];
  };

  // Get maximum allowed date (yesterday)
  const getMaxDate = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split("T")[0];
  };

  const [selectedDate, setSelectedDate] = useState(getYesterday());

  const fetchAttendanceRecords = async (date) => {
    try {
      setLoading(true);

      const payload = {
        Date: date || selectedDate,
        UserId: UID,
      };

      const response = await getAttendenceData(payload);
      console.log("API Response:", response);

      let dataArray = [];

      if (Array.isArray(response)) {
        dataArray = response;
      } else if (response?.data?.data && Array.isArray(response.data.data)) {
        dataArray = response.data.data;
      } else if (response && typeof response === "object") {
        const possibleArrays = Object.values(response).filter(Array.isArray);
        if (possibleArrays.length > 0) {
          dataArray = possibleArrays[0];
        }
      }

      console.log("Processed data array:", dataArray);

      const pending = dataArray.filter((el) => el.ATTENDANCESTATUS === 0);

      const attendanceDetails =
        isAdmin == 1
          ? pending
          : pending.filter((el) => el?.DEPARTMENTID == DepartmentId);

      // Initialize attendance data
      setAttendanceData(attendanceDetails);

      // Initialize individualCheck with the same data structure
      const initialCheckData = pending.map((item) => ({
        ...item,
        ATTENDANCESTATUS: 0, // Initialize all as unchecked
      }));
      setIndividualcheck(initialCheckData);

      // Extract unique departments
      const uniqueDepartments = [
        ...new Set(pending.map((item) => item.DepartmentName).filter(Boolean)),
      ];
      setDepartments(uniqueDepartments);

      // Extract unique profit centers
      const uniqueProfitCenters = [
        ...new Set(
          pending.map((item) => item.ProfitcenterName).filter(Boolean)
        ),
      ];
      setProfitCenters(uniqueProfitCenters);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setAttendanceData([]);
      setIndividualcheck([]);
      setDepartments([]);
      setProfitCenters([]);
    } finally {
      setLoading(false);
    }
  };

  // Load data on component mount with yesterday's date
  useEffect(() => {
    fetchAttendanceRecords(selectedDate);
  }, []);

  // Handle date change
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    fetchAttendanceRecords(newDate);
  };

  // Filter data based on search term, department, and profit center
  useEffect(() => {
    let filtered = attendanceData;

    // Filter by search term (name or code)
    if (searchTerm) {
      filtered = filtered.filter(
        (item) =>
          item.EmployeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.EmpCode?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by department
    if (selectedDepartment) {
      filtered = filtered.filter(
        (item) => item.DepartmentName === selectedDepartment
      );
    }

    // Filter by profit center
    if (selectedProfitCenter) {
      filtered = filtered.filter(
        (item) => item.ProfitcenterName === selectedProfitCenter
      );
    }

    setFilteredData(filtered);
  }, [attendanceData, searchTerm, selectedDepartment, selectedProfitCenter]);

  // Calculate pending count
  const pendingCount = filteredData.filter(
    (record) => record.ATTENDANCESTATUS === 0
  ).length;

  // Format time display
  const formatTime = (timeString) => {
    if (!timeString) return "N/A";
    const time = new Date(timeString);
    return time.toISOString().substr(11, 5);
  };

  // Helper function to check if punch times are valid
  // const hasValidPunchTimes = (record) => {
  //   const punchIn = record.PUNCHIN;
  //   const punchOut = record.PUNCHOUT;
  //   const LeaveStatus=record.LeaveStatus

  //   // Check if punch times are null, empty, or default date
  //   const isInvalidTime = (time) => {
  //     if (!time || time === "" || time === null) return true;
  //     if (time.includes("1900-01-01")) return true;
  //     return false;
  //   };

  //   // Return true if at least one punch atime is valid (either punch in OR punch out)
  //   return !isInvalidTime(punchIn) || !isInvalidTime(punchOut)||LeaveStatus;
  // };

  const hasValidPunchTimes = (record) => {
    const punchIn = record.PUNCHIN;
    const punchOut = record.PUNCHOUT;
    const LeaveStatus = record.LeaveStatus;

    // ❌ If on leave, directly return false
    if (LeaveStatus == 1) return false;

    // Helper: check if time is invalid
    const isInvalidTime = (time) => {
      if (!time || time === "" || time === null) return true;
      if (time.includes("1900-01-01")) return true;
      return false;
    };

    // ✅ Valid if at least one punch is present
    if (record.StartTime == record.EndTime) {
      return !isInvalidTime(punchIn) || !isInvalidTime(punchOut);
    } else {
      return !isInvalidTime(punchIn) && !isInvalidTime(punchOut);
    }
  };

  // Check if all currently filtered punched items are selected
  const isSelectAllPunchedChecked = () => {
    const punchedItems = filteredData.filter((item) =>
      hasValidPunchTimes(item)
    );
    if (punchedItems.length === 0) return false;

    const result = punchedItems.every((filteredItem) => {
      const checkItem = individualCheck.find(
        (item) => item.ID == filteredItem.ID
      );
      return checkItem && checkItem.ATTENDANCESTATUS === 1;
    });

    console.log("Select all punched checked status:", {
      totalFiltered: filteredData.length,
      punchedItems: punchedItems.length,
      result,
    });
    return result;
  };

  const handleSelectAllPunched = (e) => {
    const isChecked = e.target.checked;
    console.log("Select all punched clicked:", {
      isChecked,
      filteredData: filteredData.length,
    });

    const updatedData = individualCheck.map((item) => {
      // Check if this item is in the current filtered data
      const isInFilteredData = filteredData.some(
        (filtered) => filtered.ID == item.ID
      );

      if (isInFilteredData) {
        // Only select if it has valid punch times
        if (hasValidPunchTimes(item)) {
          return {
            ...item,
            ATTENDANCESTATUS: isChecked ? 1 : 0,
          };
        } else {
          // If unchecking, uncheck all items; if checking, skip invalid punch times
          return {
            ...item,
            ATTENDANCESTATUS: isChecked ? 0 : 0, // Keep as 0 for invalid punch times
          };
        }
      }
      return item; // Keep unchanged for items not in filtered data
    });

    console.log("Select all punched updated data:", updatedData);
    setIndividualcheck(updatedData);
  };

  const handleIndividualCheck = (e) => {
    const checkedItemId = e.target.value; // Keep as string to match the data
    const isChecked = e.target.checked;

    console.log("Individual check clicked:", {
      checkedItemId,
      isChecked,
      individualCheck,
    }); // Debug log

    const updatedData = individualCheck.map((item) => {
      // Use loose equality to handle string/number comparison
      if (item.ID == checkedItemId) {
        return {
          ...item,
          ATTENDANCESTATUS: isChecked ? 1 : 0,
        };
      }
      return item;
    });

    console.log("Updated data:", updatedData); // Debug log
    setIndividualcheck(updatedData);
  };

  // Get the checked status for an individual item
  const getItemCheckedStatus = (itemId) => {
    const item = individualCheck.find((item) => item.ID == itemId); // Use loose equality
    const isChecked = item ? item.ATTENDANCESTATUS === 1 : false;
    console.log("Getting checked status:", { itemId, item, isChecked }); // Debug log
    return isChecked;
  };

  const handleAppproveAttendacne = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Only send the checked items
      const checkedItems = individualCheck.filter(
        (item) => item.ATTENDANCESTATUS === 1
      );

      if (checkedItems.length === 0) {
        toast.error("Please select at least one attendance record to approve.");
        return;
      }

      const data = {
        UserId: UID,
        AttendenceRecords: checkedItems,
      };

      const response = await insertMarkAttendence(data);
      if (response.data.data.StatusCode == 200) {
        toast.success(response.data.data.message);
        fetchAttendanceRecords(selectedDate);
      } else {
        toast.error("Something went wrong");
      }
      console.log(response, "Approval response");
    } catch (error) {
      console.error("Error occurred while approving attendance:", error);
      toast.error("Error occurred while approving attendance");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">
          Attendance Approval Pendings
        </h2>
        {/* {isAdmin == 0 && attendanceData?.length > 0 && (
          <>
            {console.log(isAdmin, 'hshshs')}
            <p className="text-2xl text-gray-800">
              Department: {[...new Set(attendanceData.map((el) => el.DepartmentName))].join(", ")}
            </p>
          </>
        )} */}

        <Link to={"/"}>
          <button className="btn btn-danger">Back to Dashboard</button>
        </Link>
      </div>

      {!loading && attendanceData.length > 0 && (
        <div className="mt-4 text-sm text-gray-600">
          Showing {filteredData.length} of {attendanceData.length} records
          <span className="ml-4">| Pending Approvals: {pendingCount}</span>
        </div>
      )}

      {/* Controls Section */}
      <div className="mb-6 bg-gray-50 p-4 rounded-lg">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {/* Date Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Date
            </label>
            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              max={getMaxDate()}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Search Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Search (Name/Code)
            </label>
            <input
              type="text"
              placeholder="Enter name or code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Department Filter */}
          {isAdmin == 1 && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Department
              </label>
              <select
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">All Departments</option>
                {departments.map((dept, index) => (
                  <option key={index} value={dept}>
                    {dept}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Profit Center Filter */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Profit Center
            </label>
            <select
              value={selectedProfitCenter}
              onChange={(e) => setSelectedProfitCenter(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">All Profit Centers</option>
              {profitCenters.map((center, index) => (
                <option key={index} value={center}>
                  {center}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-8">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <p className="mt-2 text-gray-600">Loading attendance records...</p>
        </div>
      )}

      {/* Table */}
      {!loading && (
        <div className="overflow-x-auto bg-white rounded-lg shadow">
          <table className="min-w-full table-auto">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={isSelectAllPunchedChecked()}
                      onChange={handleSelectAllPunched}
                      className="mr-2"
                    />
                    Select All Punched
                  </label>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Sl No
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Employee Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Code
                </th>
                {isAdmin == 1 && (
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Department
                  </th>
                )}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Shift Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Start Time
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  End Time
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Punch In
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Punch Out
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan="10"
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    {attendanceData.length === 0
                      ? "No attendance records found for the selected date."
                      : "No records match the selected filters."}
                  </td>
                </tr>
              ) : (
                filteredData?.map((record, index) => {
                  const hasValidPunches = hasValidPunchTimes(record);
                  const punchInValid =
                    record.PUNCHIN &&
                    record.PUNCHIN !== "" &&
                    !record.PUNCHIN.includes("1900-01-01");
                  const punchOutValid =
                    record.PUNCHOUT &&
                    record.PUNCHOUT !== "" &&
                    !record.PUNCHOUT.includes("1900-01-01");

                  return (
                    <tr key={record.ID || index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <input
                          type="checkbox"
                          value={record.ID}
                          checked={getItemCheckedStatus(record.ID)}
                          onChange={handleIndividualCheck}
                          disabled={record?.LeaveStatus == 1}
                        />
                        {!hasValidPunches &&
                          // <span className="ml-2 text-xs text-red-500">No Punch</span>
                          ""}
                        {hasValidPunches &&
                          (!punchInValid || !punchOutValid) &&
                          // <span className="ml-2 text-xs text-yellow-500">Partial</span>
                          ""}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {record.EmployeeName || "N/A"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {record.EmpCode || "N/A"}
                      </td>
                      {isAdmin == 1 && (
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {record.DepartmentName || "N/A"}
                        </td>
                      )}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {record.ShiftName || "N/A"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {formatTime(record.StartTime)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {formatTime(record.EndTime)}
                      </td>
                      <td
                        className={`px-6 py-4 whitespace-nowrap text-sm ${
                          !punchInValid ? "text-red-500" : "text-gray-500"
                        }`}
                      >
                        {formatTime(record.PUNCHIN)}
                      </td>
                      <td
                        className={`px-6 py-4 whitespace-nowrap text-sm ${
                          !punchOutValid ? "text-red-500" : "text-gray-500"
                        }`}
                      >
                        {formatTime(record.PUNCHOUT)}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>

          {filteredData.length > 0 && (
            <div className="p-4">
              <button
                onClick={handleAppproveAttendacne}
                disabled={
                  loading ||
                  individualCheck.filter((item) => item.ATTENDANCESTATUS === 1)
                    .length === 0
                }
                className="bg-blue hover:bg-blue disabled:bg-gray-400 text-white font-bold py-2 px-4 rounded"
              >
                {loading ? "Processing..." : "Approve Selected Attendance"}
                {individualCheck.filter((item) => item.ATTENDANCESTATUS === 1)
                  .length > 0 &&
                  ` (${
                    individualCheck.filter(
                      (item) => item.ATTENDANCESTATUS === 1
                    ).length
                  })`}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AttendancePending;
